module.exports = __webpack_public_path__ + "static/media/Self_defence_icon.03b315d7.png";